import { useRef, type ReactNode } from 'react';
import { useCameraTransform } from '@/hooks/useCameraTransform';
import styles from '../SpatialCanvas.module.css';

/**
 * World renderer, transform half: the one element whose CSS transform is the camera.
 * Anything rendered inside is positioned in world units and mapped to the screen by
 * the compositor. Children are rendering layers (objects, interaction), not objects.
 */
export const WorldLayer = ({ children }: { children: ReactNode }) => {
  const ref = useRef<HTMLDivElement>(null);
  useCameraTransform(ref);
  return (
    <div ref={ref} className={styles.world} data-testid="world-layer">
      {children}
    </div>
  );
};
